import React from 'react';
import './SlideItem.less';

type Props = {
  title: string;
  description: string;
  imageSrc: any;
  extraComponents?: any;
  titleTestId?: string;
  descriptionTestId?: string;
  titleStyles?: any;
  descriptionStyles?: any;
  imageStyles?: any;
};

const SlideItem = ({
  titleTestId,
  descriptionTestId,
  title,
  description,
  imageSrc,
  extraComponents,
  titleStyles,
  descriptionStyles,
  imageStyles = null,
}: Props) => {
  return (
    <div style={{ height: window.innerHeight }} className="slide-item-wrapper">
      {extraComponents}
      <img
        data-testid="SlideItem-img"
        className="slide-item-img"
        src={imageSrc}
        alt={imageSrc}
        style={imageStyles}
      />
      <div
        data-testid={titleTestId}
        className="slide-item-title"
        style={titleStyles}
      >
        {title}
      </div>
      <div
        data-testid={descriptionTestId}
        className="slide-item-description"
        style={descriptionStyles}
      >
        {description}
      </div>
    </div>
  );
};

export default SlideItem;
